module.exports = __webpack_public_path__ + "img/espiral.b701dde0.svg";